module.exports = __webpack_public_path__ + "media/images/brand/150/MARQUESBRANDINGCO LOGO VERTICAL W-4e67e55567b9e5e8f6c6d9899dc9d4dc.png";